import { nodeInstance } from "@/plugins/axios";

const automaticRegistrationServices = {};

automaticRegistrationServices.registerUser = data => {
  return nodeInstance.post("/api/formUserEnrolment", { jsonData: data });
};

export default automaticRegistrationServices;